import React from 'react';

/**
 * Floating WhatsApp CTA — one-tap contact link, positioned at the
 * bottom-left so it doesn't collide with the existing chat widget.
 */
const WhatsAppFab = () => {
  const phone = '919251854963';
  const message = encodeURIComponent(
    "Hello RCD, I'd like to enquire about a project."
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with RCD on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-[92px] right-6 md:bottom-[96px] md:right-[26px] z-[120] group flex flex-row-reverse items-center gap-3 rcd-whatsapp-pulse"
    >
      <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25d366] shadow-[0_18px_40px_-10px_rgba(37,211,102,0.6)] flex items-center justify-center transition-transform group-hover:scale-110">
        {/* Inline WhatsApp glyph (kept as SVG so no extra icon lib pull) */}
        <svg viewBox="0 0 24 24" width="26" height="26" fill="#ffffff" aria-hidden="true">
          <path d="M20.52 3.48A11.9 11.9 0 0 0 12.05 0C5.5 0 .18 5.32.18 11.87c0 2.09.55 4.13 1.6 5.94L0 24l6.35-1.66a11.86 11.86 0 0 0 5.7 1.45h.01c6.55 0 11.87-5.32 11.87-11.87 0-3.17-1.24-6.16-3.41-8.44Zm-8.47 18.28h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.77.99 1.01-3.67-.24-.38a9.87 9.87 0 0 1-1.51-5.24c0-5.44 4.43-9.87 9.88-9.87 2.64 0 5.12 1.03 6.98 2.9a9.83 9.83 0 0 1 2.89 6.97c0 5.45-4.43 9.89-9.88 9.89Zm5.42-7.4c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.93 1.15-.17.2-.34.22-.63.07a8.11 8.11 0 0 1-2.38-1.47 8.98 8.98 0 0 1-1.65-2.05c-.17-.3-.02-.46.13-.6.14-.13.3-.34.44-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.19-.24-.58-.48-.5-.66-.51l-.56-.01c-.19 0-.5.07-.76.37-.27.3-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.2 2.07 3.15 5.02 4.42.7.3 1.25.48 1.68.62.71.23 1.35.2 1.86.12.57-.09 1.75-.72 2-1.4.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
        </svg>
      </span>
      <span className="hidden md:inline-block px-4 py-2 bg-white/95 backdrop-blur text-[#1a1614] text-xs tracking-[0.22em] uppercase shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppFab;
